import React from 'react'
import { LANGUAGE_OPTIONS, LANGUAGE_NAMES } from '../LanguageSwitcher/languages'
import * as styles from './BreakSlugField.module.scss'

export type BreakSlugEntry = {
  code: string
  slug: string
}

// Ensures there is exactly one entry per supported language, in the same order
// as LANGUAGE_OPTIONS. Adding a language to LANGUAGE_OPTIONS automatically adds
// a row here with no change to this component or the Break block.
export function normalizeEntries(value?: BreakSlugEntry[]): BreakSlugEntry[] {
  const byCode = new Map((value ?? []).map(e => [e.code, e]))
  return LANGUAGE_OPTIONS.map(opt => ({
    code: opt.value,
    slug: byCode.get(opt.value)?.slug ?? '',
  }))
}

export const BreakSlugField = ({
  value,
  onChange,
}: {
  value: BreakSlugEntry[]
  onChange: (v: BreakSlugEntry[]) => void
}) => {
  const entries = normalizeEntries(value)

  const updateSlug = (code: string, slug: string) => {
    onChange(entries.map(e => (e.code === code ? { ...e, slug } : e)))
  }

  return (
    <div>
      {entries.map(entry => (
        <div key={entry.code} className={styles.row}>
          <span className={styles.label}>
            {LANGUAGE_NAMES[entry.code] ?? entry.code} — break slug
          </span>
          <input
            type="text"
            className={styles.input}
            value={entry.slug ?? ''}
            onChange={e => updateSlug(entry.code, e.target.value)}
            placeholder="break-permalink"
          />
        </div>
      ))}
    </div>
  )
}
